
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/financials",
      function () {
        return require("private-next-pages/financials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/financials"])
      });
    }
  